import icon1 from "images/new/icons/247-icon.svg";
import icon2 from "images/new/icons/lock-icon.svg";
import icon3 from "images/new/icons/safeguarded-icon.svg";
import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

interface FeatureBlock {
  id: number;
  icon: string;
  title: string;
  description: string;
}

interface FeaturesBlockCarouselProps {
  className?: string;
}

const featuresData: FeatureBlock[] = [
  {
    id: 1,
    icon: icon1,
    title: "24/7 support",
    description: "Our business, security and fraud specialists are here by phone or online, wherever you're calling from.",
  },
  {
    id: 2,
    icon: icon2,
    title: "Security",
    description: "Encryption, biometrics and real-time payment approvals keep your money safe and away from thieves.",
  },
  {
    id: 3,
    icon: icon3,
    title: "Safeguarded",
    description: "Advanced online portal for easy and secure account management with real-time monitoring and alerts.",
  },
];

const FeaturesBlockCarousel: React.FC<FeaturesBlockCarouselProps> = ({ className = "" }) => {
  return (
    <section className={`relative py-16 ${className}`}>
      <div className="container mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-5xl font-normal mb-5">Your money, protected</h2>
          <p className="text-gray-500 text-base sm:text-xl">Our security systems are built to keep every penny safe and available any time.</p>
        </div>

        {/* Features Carousel */}
        <div className="relative">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={30}
            slidesPerView={1.2}
            loop={false}
            navigation={false}
            className="!overflow-visible"
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
          >
            {featuresData.map((feature) => (
              <SwiperSlide key={feature.id}>
                <div className="bg-gray-100 rounded-3xl p-8 h-full cursor-pointer group">
                  {/* Icon */}
                  <div className="mb-6">
                    <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                      <img src={feature.icon} alt="" className="w-6 h-6 object-contain" />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold text-slate-700 mb-4">{feature.title}</h3>
                  <p className="text-gray-600 text-base">{feature.description}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default FeaturesBlockCarousel;
